import React from 'react';
import { Box } from '@mui/material';
import AudioPlayer from './AudioPlayer';
import type { ListOptionsType } from 'types/common/DropdownOption';
import BoardNodeTranscription from './BoardNodeTranscription';

type AudioNodeFileType = {
  fileSize: string;
  fileType: string;
  id: string;
  isDeleted: boolean;
  originalFileName: string;
  url: string;
};

type AudioNodeProps = {
  initialContent?: string;
  onError?: ((errorMessage: string) => void) | undefined;
  setNodeSpecificOptions: React.Dispatch<
    React.SetStateAction<ListOptionsType[]>
  >;
};

function AudioNode({ initialContent, onError }: AudioNodeProps) {
  const nodeData: AudioNodeFileType[] = initialContent
    ? JSON.parse(initialContent)?.files
    : null;

  const audioUrl = nodeData?.[0]?.url || '';

  return (
    <Box p={2} pt={0} onClick={(event) => event.stopPropagation()}>
      <AudioPlayer audioUrl={audioUrl} onError={onError} />
      <BoardNodeTranscription fileID={nodeData?.[0]?.id} />
    </Box>
  );
}

export default AudioNode;
